// functions the read session storage and returns a boolen
// if the page should be visible or not based on page : string  and routes object
export const isMenuItemVisible = (page, routes) => {
  try {
    if (routes[page] !== undefined) {
      return routes[page];
    } else {
      return true;
    }
  } catch (error) {
    return false;
  }
};
